import App from "./App.svelte";
import {
  CurrentStateName,
  GameStateStore,
  GameStatesStore,
  ItemsStore,
  PlayerId,
  PlayerOrder,
  PlayersStore,
  SetupStore,
  SelectedActions,
  Hearts,
  MonsterStore,
  CraftStore,
  DecideStore,
  BattleLogs,
  SwitchMonster,
  PotionsStore,
  PotionsDiscardPile,
  UsablePotions,
  RogueCounter,
  AlchemistCounter,
  MerchantTokenPosition,
  Top3Potions,
  ItemsToPlace,
} from "./lib/stores/gameStore";
import {
  onEnteringState,
  onLeavingState,
  onNotification,
} from "./lib/notifications";

window.__setup = (gamedata, game) => {
  window.GAME = game;
  PlayerId.set(gamedata.playerId);
  PlayersStore.set(gamedata.players);
  GameStatesStore.set(gamedata.gamestates);
  GameStateStore.set(gamedata.gamestate);
  SetupStore.set(gamedata.setup);
  CurrentStateName.set(gamedata.gamestate.name);
  SelectedActions.set(gamedata.allActions || []);
  PlayerOrder.set(gamedata.playerorder);
  ItemsStore.set(gamedata.items);
  Hearts.set(gamedata.hearts);
  MonsterStore.set(gamedata.setup.monsters);
  CraftStore.set(gamedata.possibleToCraft);
  DecideStore.set(gamedata.decideCraftMaterial);
  SwitchMonster.set(gamedata.switchMonster);
  PotionsStore.set(gamedata.potions);
  PotionsDiscardPile.set(gamedata.potionsDiscardPile);
  UsablePotions.set(gamedata.usablePotions);

  RogueCounter.set(gamedata.rogueCounter);
  AlchemistCounter.set(gamedata.alchemistCounter);
  MerchantTokenPosition.set(gamedata.merchantToken);
  Top3Potions.set(gamedata.top3Potions);
  ItemsToPlace.set(gamedata.itemsToPlace);

  if (gamedata.battleLog) {
    BattleLogs.set([gamedata.battleLog]);
  }
  // console.log("INIT", gamedata);
  const app = new App({
    target: document.getElementById("game_ui"),
  });
  // mount(App, { target: document.getElementById("game_ui") });
  return { onNotification, onEnteringState, onLeavingState };
};
